export const APP_NAME = 'Udhaar Portal';
export const CONTACT_NUMBER = '9560335624';
export const NBFC_ADDRESS = '15, 3rd Floor Sant Nagar, east of Kailash, New Delhi-110065';
export const CONTACT_EMAIL = 'info@udhaarportal.com';
export const NBFC_NAME = 'Aman Fincap Limited';